/**
 * Containervervoer plaats van bestemming - tiered pricing (2026).
 * Distance from destination port to delivery address or warehouse.
 * Base price = (Prijs 2026 + Tol Waalhaven) × 1.05 diesel surcharge.
 */

export const SELLING_PRICE_MARKUP_EUR = 120;

/** Per-km rate for distances over 300 km (€1.60 + 5% diesel) */
export const OVER_300_KM_RATE_EUR = 1.68;

/** Tier: km_from, km_to, base price (EUR, inkoop incl. 5% diesel) */
export const CONTAINERVERVOER_TIERS: Array<{
  kmFrom: number;
  kmTo: number;
  price: number;
}> = [
  { kmFrom: 0, kmTo: 10, price: 215.17 },
  { kmFrom: 11, kmTo: 20, price: 240.81 },
  { kmFrom: 21, kmTo: 30, price: 266.45 },
  { kmFrom: 31, kmTo: 40, price: 292.09 },
  { kmFrom: 41, kmTo: 50, price: 322.98 },
  { kmFrom: 51, kmTo: 60, price: 348.62 },
  { kmFrom: 61, kmTo: 70, price: 374.26 },
  { kmFrom: 71, kmTo: 80, price: 394.65 },
  { kmFrom: 81, kmTo: 90, price: 430.79 },
  { kmFrom: 91, kmTo: 100, price: 461.69 },
  { kmFrom: 101, kmTo: 110, price: 487.33 },
  { kmFrom: 111, kmTo: 120, price: 512.97 },
  { kmFrom: 121, kmTo: 130, price: 517.61 },
  { kmFrom: 131, kmTo: 140, price: 543.25 },
  { kmFrom: 141, kmTo: 150, price: 600.39 },
  { kmFrom: 151, kmTo: 160, price: 631.28 },
  { kmFrom: 161, kmTo: 170, price: 662.17 },
  { kmFrom: 171, kmTo: 180, price: 698.31 },
  { kmFrom: 181, kmTo: 190, price: 729.2 },
  { kmFrom: 191, kmTo: 200, price: 765.35 },
  { kmFrom: 201, kmTo: 210, price: 796.24 },
  { kmFrom: 211, kmTo: 220, price: 832.38 },
  { kmFrom: 221, kmTo: 230, price: 873.77 },
  { kmFrom: 231, kmTo: 240, price: 915.16 },
  { kmFrom: 241, kmTo: 250, price: 967.05 },
  { kmFrom: 251, kmTo: 260, price: 997.94 },
  { kmFrom: 261, kmTo: 270, price: 1034.08 },
  { kmFrom: 271, kmTo: 280, price: 1059.72 },
  { kmFrom: 281, kmTo: 290, price: 1101.11 },
  { kmFrom: 291, kmTo: 300, price: 1132.0 },
];
